import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { clinicInfo, heroImages } from '../mockData';
import { openWhatsApp } from '@/lib/whatsapp';

const CTASection = () => {
  const handleWhatsAppClick = () => {
    openWhatsApp({
      section: 'cta',
      message: 'Olá! Vim pelo site e quero agendar uma avaliação sem compromisso.',
    });
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-deep via-[#1a3a52] to-brand-ink py-24">
      <div className="absolute inset-0 opacity-[0.12]" aria-hidden>
        <div className="absolute -left-20 top-0 h-[420px] w-[420px] rounded-full bg-brand-gold blur-3xl" />
        <div className="absolute -right-10 bottom-0 h-80 w-80 rounded-full bg-white blur-3xl" />
      </div>
      <div
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,255,255,0.08),transparent_50%)]"
        aria-hidden
      />

      <div className="container relative z-10 mx-auto px-4">
        <div className="grid items-center gap-14 md:grid-cols-2">
          <div className="space-y-8">
            <p className="text-[0.7rem] font-semibold uppercase tracking-[0.32em] text-white/55">
              Próximo passo
            </p>
            <h2 className="font-display text-4xl font-semibold leading-tight tracking-tight text-white md:text-5xl">
              Dê o primeiro passo — é sem compromisso
            </h2>
            <p className="text-lg font-light leading-relaxed text-white/80">
              Chame no WhatsApp, tire suas dúvidas e agende sua avaliação. A gente explica tudo com
              calma e parcela do jeito que cabe no seu bolso.
            </p>

            <ul className="space-y-4">
              {[
                'Avaliação completa — você entende antes de decidir',
                'Plano feito só para o seu caso',
                'Parcelamento facilitado no cartão',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-white/85">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-gold" />
                  {item}
                </li>
              ))}
            </ul>

            <div>
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="group inline-flex items-center gap-3 rounded-full bg-white px-8 py-4 text-base font-semibold text-brand-ink shadow-brand-lg transition hover:bg-brand-cream"
              >
                <Phone className="h-5 w-5 text-brand-deep" />
                Chamar no WhatsApp
                <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
              </button>
              <p className="mt-4 text-sm text-white/50">
                Resposta rápida • Sem compromisso • Parcelamento facilitado
              </p>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="absolute -inset-2 rounded-[1.75rem] bg-gradient-to-br from-brand-gold/25 to-transparent blur-xl" aria-hidden />
            <div className="relative overflow-hidden rounded-[1.5rem] shadow-brand-xl ring-1 ring-white/15">
              <img
                src={heroImages.procedure}
                alt="Atendimento profissional"
                className="h-[500px] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/70 via-brand-ink/10 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
